import { PageContent, PageLayout } from '@reapitform/dashboard-ui'
import SidebarInformation from './view/sidebar-information'
import BusinessDetailsSection from './view/business-details-section'
import ContactDetailsSection from './view/contact-details-section'
import PaymentMethodsSection from './view/payment-methods-section'

export const SettingsPage: React.FC = () => {
  return (
    <PageLayout pageTitle="Settings">
      <PageContent>
        <BusinessDetailsSection />
        <ContactDetailsSection />
        <PaymentMethodsSection />
      </PageContent>
      <SidebarInformation />
    </PageLayout>
  )
}
